<template>
  <div class="login-card">
    <!-- brand logo -->
    <div style="width: 100%; display: flex; justify-content: center; padding: 15px 0 15px 0;">
      <v-img :src="require('@/assets/logo.png')" max-height="80px" max-width="80px" alt="logo" contain
        class="me-3"></v-img>
    </div>

    <div style="width: 100%; display: flex; justify-content: center;">
      <p class="welcome-title">
        {{ $i18n.t("ppt_add_in_main.login_home_title") }}
        <!-- <span class="tm-mark">TM</span> -->
      </p>
    </div>
    <!--/ brand logo -->

    <!-- login form -->
    <v-form :disabled="isLoading">
      <v-text-field v-model="email" v-show="loginType === 1" outlined
        :label="$i18n.t('ppt_add_in_main.login_home_account_hint')"
        :placeholder="$i18n.t('ppt_add_in_main.login_home_account_empty')" :error-messages="errorMessages.email"
        :rules="[validators.emailorMobileValidator]" hide-details="auto" autofocus style="margin-top: 20px;"></v-text-field>

      <v-text-field v-model="mobile" v-show="loginType === 10" outlined label="Mobile" placeholder="mobile"
        :error-messages="errorMessages.mobile" :rules="[validators.mobileValidator]" hide-details="auto"
        autofocus style="margin-top: 20px;"></v-text-field>

      <v-text-field v-model="password" outlined :type="isPasswordVisible ? 'text' : 'password'"
        :label="$i18n.t('ppt_add_in_main.login_home_password_hint')"
        :placeholder="$i18n.t('ppt_add_in_main.login_home_password_empty')" :error-messages="errorMessages.password"
        :append-icon="isPasswordVisible ? 'mdi-eye-off' : 'mdi-eye'" hide-details="auto"
        @click:append="isPasswordVisible = !isPasswordVisible" @keydown.enter="onClickLoginButton" style="margin-top: 20px;"></v-text-field>

      <!-- <div class="d-flex align-center justify-space-between flex-wrap">
        <v-checkbox
          v-model="checkRememberMe"
          hide-details
          label="Remember Me"
          class="mt-0 ml-4 text-sm"
        >
        </v-checkbox> -->
      <!-- forget link -->
      <!-- <router-link :to="{ name: 'auth-forgot-password' }" class="ms-3">
          Forgot Password?
        </router-link> -->
      <!-- </div> -->

      <div style="display: flex; justify-content: center; align-items: center; flex-direction: column; margin-top: 30px; ">
        <v-btn class="get-started-btn" width="50%" :loading="isLoading" @click="onClickLoginButton">
          {{ $i18n.t("ppt_add_in_main.login") }}
        </v-btn>
      </div>
      <div style="display: flex; justify-content: center; align-items: center; flex-direction: column; margin-top: 5px; margin-bottom: 10px;">
        <v-btn text @click="onRegister"> {{ $i18n.t("signup.txt_btn_go_signup") }} </v-btn>
      </div>
    </v-form>

    <!-- create new account  -->
    <!-- <v-card-text class="d-flex align-center justify-center flex-wrap mt-2">
      <p class="mb-0 me-2">New on our platform?</p>
      <router-link :to="{ name: 'auth-register' }">
        Create an account
      </router-link>
    </v-card-text> -->

    <!-- divider -->
    <!-- <v-card-text class="d-flex align-center py-0">
      <v-divider></v-divider>
      <span class="mx-5">or</span>
      <v-divider></v-divider>
    </v-card-text> -->

    <!-- socail links -->
    <!-- <v-card-actions class="d-flex justify-center pb-2">
      <v-btn v-for="link in socialLink" :key="link.icon" icon class="ms-1">
        <v-icon :color="$vuetify.theme.dark ? link.colorInDark : link.color">
          {{ link.icon }}
        </v-icon>
      </v-btn>
    </v-card-actions> -->
  </div>
</template>

<script>
// 这里可以导入其他文件(比如:其他组件,工具JS,json文件,图文件等等)
import { userKeys } from "@/service/wd_app_config.js";

//例如: import <组件名称> from  <组建路径>
import {
  required,
  emailValidator,
  mobileValidator,
  emailorMobileValidator
} from "@/utils/validation.js";

import {
  mdiFacebook,
  mdiTwitter,
  mdiGithub,
  mdiGoogle,
} from "@mdi/js";

export default {
  //import 引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    //这里存放数据
    return {
      isPasswordVisible: false,
      email: "",
      mobile: "",
      password: "",
      loginType: 1,
      errorMessages: [],
      validators: {
        required,
        emailValidator,
        mobileValidator,
        emailorMobileValidator
      },
      socialLink: [
        {
          icon: mdiFacebook,
          color: "#4267b2",
          colorInDark: "#4267b2",
        },
        {
          icon: mdiTwitter,
          color: "#1da1f2",
          colorInDark: "#1da1f2",
        },
        {
          icon: mdiGithub,
          color: "#272727",
          colorInDark: "#fff",
        },
        {
          icon: mdiGoogle,
          color: "#db4437",
          colorInDark: "#db4437",
        },
      ],

      checkRememberMe: false,
    };
  },
  //计算机属性 类似与data概念
  computed: {},
  //监控data中数据变化
  watch: {},
  methods: {
    onRegister() {
      this.$emit("gotoSignup");
    },
    reserve() {
      this.loading = true;
      setTimeout(() => (this.loading = false), 2000);
    },
    onClickLoginButton() {
      let accountName = '';

      // if (this.loginType === 10) accountName = this.mobile;
      // else if (this.loginType === 1) accountName = this.email;
      // else throw "Unsupport login type.";
      accountName = this.email;

      if (this.validators.emailValidator(accountName) == true) {
        this.loginType = 1
      } else if (this.validators.mobileValidator(accountName) == true) {
        this.loginType = 10;
      } else {
        this.$message.error(this.$i18n.t("valiad.email_mobile_valida"));
        return;
      }

      if (accountName != '' && this.password != '') {
        // if (!this.checkRememberMe) {
        //   localStorage.removeItem(userKeys.key_login_RememberMe);
        //   localStorage.removeItem(userKeys.key_login_AccountName);
        //   localStorage.removeItem(userKeys.key_login_Password);
        // } else {
          localStorage.setItem(
            userKeys.key_login_RememberMe,
            this.checkRememberMe
          );
          localStorage.setItem(userKeys.key_login_AccountName, accountName);
          const Base64 = require("js-base64").Base64;
          localStorage.setItem(
            userKeys.key_login_Password,
            Base64.encode(this.password)
          );
        // }

        this.$emit("login", {
          accountName: accountName,
          accountType: this.loginType,
          password: this.password,
        });
      } else {
        this.$message.error(this.$i18n.t("login.required_remind_text"))
      }
    },
  },
  //生命周期-创建完成(可以访问当前this实例)
  created() {
    // no use logic, because logout will clear all localstorage data
    /** this.checkRememberMe = localStorage.getItem(userKeys.key_login_RememberMe);
    if (this.checkRememberMe) {
      this.email = localStorage.getItem(userKeys.key_login_AccountName);
      const Base64 = require("js-base64").Base64;
      this.password = Base64.decode(
        localStorage.getItem(userKeys.key_login_Password)
      );
    } */
  }
};
</script>

<style scoped>

.login-card {
  width: 80%;
  background: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.welcome-title {
  font-size: 18px;
  /* font-weight: 300; */
  color: #323130;
  margin: -20px 0 12px 0;
  font-weight: bold;
  letter-spacing: -0.5px;
  position: relative; 
  display: inline-block; 
  padding-right: 16px; 
}

.tm-mark {
  position: absolute;
  top: -2px; 
  right: 0;
  font-size: 9px; 
  font-weight: normal;
  color: #666;
  vertical-align: super;
  line-height: 1;
}

.get-started-btn {
  width: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 16px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}
</style>
